import {useEffect, useState} from 'react';
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {NavLink, useNavigate} from "react-router-dom";
import {ListGroup} from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import {discordAuthLink} from "../../config";
import spendableItem from "../../resources/spendableItem.png";

const Header = props => {

    const isSignedIn = useSelector(({UserReducer}) => UserReducer.isLoggedIn);
    const user = useSelector(({UserReducer}) => UserReducer.user);

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleDiscordLogin = async () => {
        const popupWindow = window.open(
            `${discordAuthLink}`,
            "_blank",
            "width=500, height=700",
        );
        if (window.focus) popupWindow.focus();
    };

    useEffect(() => {

    }, []);

    return (
        <header className="header">
            <div className="d-flex justify-content-between align-items-center">
                <div className="header-logo">
                    <NavLink to="/">
                        <img src="/logo.png" alt="logo" className="img-fluid" />
                    </NavLink>
                </div>
                <div className="header-menu d-lg-block d-none">
                    <ul className="pl-0 mb-0 d-flex align-items-center">
                        <li>
                            <NavLink to="/">HOME</NavLink>
                        </li>
                        {/*<li>*/}
                        {/*    <NavLink to="/">BONUS</NavLink>*/}
                        {/*</li>*/}
                        <li>
                            <NavLink to="/leaderboard">LEADERBOARD</NavLink>
                        </li>
                        {/*<li>*/}
                        {/*    <NavLink to="/">BONUS HUNTS</NavLink>*/}
                        {/*</li>*/}
                        {/*<li>*/}
                        {/*    <NavLink to="/">TASKS</NavLink>*/}
                        {/*</li>*/}
                        {/*<li>*/}
                        {/*    <NavLink to="/">REWARDS</NavLink>*/}
                        {/*</li>*/}
                        {/*{user?.isAdmin && (*/}
                        {/*    <li>*/}
                        {/*        <NavLink to="/admin">Admin</NavLink>*/}
                        {/*    </li>*/}
                        {/*)}*/}
                    </ul>
                </div>
                <div className="header-discord-text d-lg-block d-none">
                    {user ? (
                            <>
                                <div className="headerProfileWrapper">
                                    <div className="spendableItem"><img src={spendableItem} alt=""/><div>{user.coins}</div></div>
                                    <a className="headerProfileLink" onClick={() => navigate(`/account`)}>
                                        <img src={user.profileImageUrl} alt="" className="headerProfileImage"/>
                                    </a>
                                </div></>) : (
                        <a className="btn btn-primary btn-nick" name="account" onClick={handleDiscordLogin}>
                            <img src="/discord.svg" alt="discord" className="img-fluid" /> Log in
                        </a>
                    )}
                </div>
                <i
                    className="fa-solid fa-bars small-menu-btn d-inline-block d-lg-none ms-auto order-1"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasExample"
                    aria-controls="offcanvasExample"
                    onClick={handleShow}></i>
            </div>

            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ListGroup variant="flush">
                        <ListGroup.Item>
                            <NavLink to="/" onClick={handleClose}>
                                Home
                            </NavLink>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <NavLink to="/leaderboard" onClick={handleClose}>
                                Leaderboard
                            </NavLink>
                        </ListGroup.Item>

                        {/*{user ? (<ListGroup.Item><NavLink to="/account">*/}
                        {/*    <div style={{display:'flex', justifyContent:'space-between', alignItems: 'center'}}>*/}
                        {/*        Account: {user.displayName}*/}
                        {/*        <div className="spendableItem" style={{display: 'flex',*/}
                        {/*            justifyContent: 'flex-end',*/}
                        {/*            alignItems: 'center',*/}
                        {/*            background: '#1C1C1C',*/}
                        {/*            borderRadius: '15px',*/}
                        {/*            padding: '5px 10px'*/}
                        {/*        }}><img src="" alt=""/><div>{user.coins}</div></div>*/}
                        {/*    </div>*/}
                        {/*</NavLink></ListGroup.Item>):(*/}
                        {/*    <ListGroup.Item><a href="#" onClick={handleDiscordLogin}>Sign In</a></ListGroup.Item>*/}
                        {/*)}*/}

                    </ListGroup>
                </Offcanvas.Body>
            </Offcanvas>
        </header>
    );
}

export default Header;